import { render, staticRenderFns } from "./AdminRFQButton.vue?vue&type=template&id=2852ef6f"
import script from "./AdminRFQButton.vue?vue&type=script&lang=js"
export * from "./AdminRFQButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports